import React, { useState, useEffect } from 'react';
import { useTheme } from '../theme/ThemeContext';


import * as d3 from 'd3';

const RegularLegend = ({ colorDict, scatterplot, colors, scatterColorCategory, setCatigoricalResolution, styles }) => {

    // console.log(colorDict);

    const [isCollapsed, setIsCollapsed] = useState(false);
    const { theme } = useTheme();

    // const legendOrder = [
    //     'Coastal',
    //     'Marine',
    //     'Oceanic',
    //     'Coral_reef',
    //     'Lake',
    //     'Fecal',
    //     'Digestive_system',
    //     'Human',
    //     'Oral',
    //     'Supragingival_plaque',
    //     'Digestive_system (Human)',
    //     'Fecal (Animal)',
    //     'Fecal (Human)',
    //     'Intestine',
    //     'Birds',
    //     'Sediment',
    //     'Plants',
    //     'Rhizosphere',
    //     'Agricultural',
    //     'Soil',
    //     'Mixed',
    //     'Other',
    // ];

    const divStyleLegend = {
        ...styles,
        maxHeight: '170px',
        maxWidth: '900px',
        overflow: 'auto'
    };

    const handleLegendClick = (category) => {
        let colorCategoryIndex = Object.keys(colorDict).indexOf(category);
        let pointColorIndexes = [];
        for (let i = 0; i < colors.length; i++) {
            if (colors[i] === colorCategoryIndex) pointColorIndexes.push(i);
        }
        scatterplot.select(pointColorIndexes);
    };

    useEffect(() => {
        if (!colorDict || Object.keys(colorDict).length === 0) {
            return;
        }

        d3.select('#legendContainer').selectAll('*').remove();

        // const colorEntries = Object.entries(colorDict);
        // const colorEntries = Object.entries(colorDict)
        //     .filter(([key]) => !key.startsWith('user_'));

        // const colorEntries = Object.entries(colorDict)
        //     .filter(([key]) => !key.startsWith('user_') && key !== '__user__');

        const colorEntries = Object.entries(colorDict)
            .filter(([key]) => !key.startsWith('user_') && key !== '__user__')
            .sort(([a], [b]) => a.localeCompare(b));



        // const colorEntries = legendOrder
        //     .filter(key => key in colorDict)
        //     .map(key => [key, colorDict[key]]);

        // const numColumns = 2;
        const numColumns = (scatterColorCategory === "environment_material" || scatterColorCategory === "geographic_location") ? 2 : 3;
        // const numColumns = 1

        // const numColumns = 3;
        const itemHeight = 35;

        const numRows = Math.ceil(colorEntries.length / numColumns);

        const svg = d3.select('#legendContainer')
            .append('svg')
            .attr('height', numRows * itemHeight)
            .style('padding-top', '0px')
            .style('padding-left', '15px');

        const legendGroup = svg.selectAll('g')
            .data(colorEntries)
            .enter()
            .append('g')
            .attr('class', 'legendGroup')
            .style('cursor', 'pointer')
            .on('click', (event, d) => {
                handleLegendClick(d[0]);
            });

        legendGroup.append('rect')
            .attr('x', 0)
            .attr('y', 4)
            .attr('width', 12)
            .attr('height', 12)
            .attr('fill', d => `rgb(${d[1][0]}, ${d[1][1]}, ${d[1][2]})`);

        legendGroup.each(function (d) {
            const label = d[0].replace(/_/g, ' ').replace(/:/g, ' ').replace(/root/g, ' ');
            const words = label.split(' ');
            let line = '';
            const lines = [];
            // const lineHeight = 10;
            const lineHeight = 15;
            const x = 20;
            let y = 17;

            words.forEach(word => {
                const testLine = line + word + ' ';
                if (testLine.length > 50 && line.length > 0) {
                    lines.push(line);
                    line = word + ' ';
                } else {
                    line = testLine;
                }
            });
            lines.push(line);

            d3.select(this).selectAll('text')
                .data(lines)
                .enter()
                .append('text')
                .attr('x', x)
                // .attr('y', (d, i) => y + i * lineHeight)
                .attr('y', (d, i) => y + i * lineHeight)
                .text(d => d)
                // .style('fill', '#fff')
                .style('fill', theme.colors.text) // this text color does not change correctly
                // .style('font-size', '19px');
                // .style('font-size', '22px');
                .style('font-size', '19px');
        });

        const columnMaxWidth = new Array(numColumns).fill(0);

        legendGroup.each(function (d, i) {
            const legendItem = d3.select(this);
            const bbox = legendItem.node().getBBox();
            const width = bbox.width;
            const columnIndex = i % numColumns;
            if (width > columnMaxWidth[columnIndex]) {
                columnMaxWidth[columnIndex] = width;
            }
        });

        // calculate x positions based on maximum widths
        let columnXPositions = [];
        let xPosition = 0;
        const columnPadding = 10;
        for (let i = 0; i < numColumns; i++) {
            columnXPositions.push(xPosition);
            xPosition += columnMaxWidth[i] + columnPadding;
        }

        // update positions of legend items
        legendGroup.attr('transform', (d, i) => {
            const columnIndex = i % numColumns;
            const x = columnXPositions[columnIndex];
            const y = Math.floor(i / numColumns) * itemHeight;
            return `translate(${x}, ${y})`;
        });

        // adjust SVG width
        svg.attr('width', xPosition);

    }, [scatterplot, colorDict, colors, scatterColorCategory, theme]);

    return (
        <div style={divStyleLegend}>
            <div id="legendContainer"></div>
        </div>
    );
};

export default RegularLegend;